// Bausteine für Datenquellen: Newsticker/Feed, Termine, Tabelle. Daten kommen ausschliesslich aus dem Manifest
// (RenderContext.data), Bilder als Assets (resolveAsset). Text immer über textContent (DQ-SEC-030).
import { addDays, cellMatchesDay, eventSpan, eventsOnDay, ymdIn, zonedMidnight } from './data.js';
import { clear, cssSafe, h, placeholder } from './dom.js';
import { FONT_STACKS } from './render.js';
export const DATA_CSS = `
    .wl-feed { width: 100%; height: 100%; box-sizing: border-box; overflow: hidden; }
    .wl-feed.tk { display: flex; align-items: center; white-space: nowrap; }
    .wl-feed .ft { display: inline-block; padding-left: 100%; white-space: nowrap; animation: wl-scroll linear infinite; }
    .wl-feed .sep { opacity: .9; padding: 0 1.2em; }
    .wl-feed h2, .wl-cal h2, .wl-tab h2 { margin: 0 0 .5em; font-size: 1.25em; text-transform: uppercase; letter-spacing: .04em; }
    .wl-feed .list { display: flex; flex-direction: column; gap: .7em; height: 100%; padding: 1.2cqh 1.6cqh; box-sizing: border-box; overflow: hidden; }
    .wl-feed .it { display: flex; gap: .8em; align-items: flex-start; min-height: 0; }
    .wl-feed .it img { width: 5.5em; height: 3.6em; object-fit: cover; border-radius: .3em; flex: none; }
    .wl-feed .tt { font-weight: 700; line-height: 1.2; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden; }
    .wl-feed .tx { opacity: .8; font-size: .8em; line-height: 1.3; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden; margin-top: .2em; }
    .wl-feed .dt { font-size: .7em; font-weight: 700; letter-spacing: .03em; margin-bottom: .15em; }
    .wl-feed .cards { position: relative; width: 100%; height: 100%; }
    .wl-feed .card { position: absolute; inset: 0; display: flex; flex-direction: column; opacity: 0; transition: opacity .8s; }
    .wl-feed .card.on { opacity: 1; }
    .wl-feed .card.wide { flex-direction: row; }
    .wl-feed .card img { width: 100%; height: 50%; object-fit: cover; flex: none; }
    .wl-feed .card.wide img { width: 45%; height: 100%; }
    .wl-feed .card .body { padding: 1.4cqh 2cqh; min-height: 0; overflow: hidden; flex: 1; display: flex; flex-direction: column; justify-content: center; }
    .wl-feed .card .tt { font-size: 1.35em; -webkit-line-clamp: 3; }
    .wl-feed .card .tx { -webkit-line-clamp: 5; font-size: .85em; }
    .wl-cal, .wl-tab { width: 100%; height: 100%; padding: 1.6cqh 2cqh; box-sizing: border-box; overflow: hidden; display: flex; flex-direction: column; }
    .wl-cal .rows { flex: 1; min-height: 0; overflow: hidden; }
    .wl-cal .day { font-size: .75em; font-weight: 700; text-transform: uppercase; letter-spacing: .05em; margin: .7em 0 .25em; opacity: .85; }
    .wl-cal .day:first-child { margin-top: 0; }
    .wl-cal .ev { display: flex; gap: .8em; padding: .35em 0 .35em .5em; border-bottom: 1px solid rgba(255,255,255,.12); border-left: .2em solid transparent; }
    .wl-cal .ev .t { font-weight: 700; white-space: nowrap; min-width: 6.2em; }
    .wl-cal .ev .n { min-width: 0; }
    .wl-cal .ev .n b { display: block; font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .wl-cal .ev .n small { display: block; opacity: .7; font-size: .75em; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .wl-cal .ev.past { opacity: .35; }
    .wl-cal .grid { flex: 1; min-height: 0; display: flex; position: relative; }
    .wl-cal .hours { width: 3.2em; position: relative; flex: none; font-size: .7em; opacity: .7; }
    .wl-cal .hours span { position: absolute; right: .5em; transform: translateY(-50%); }
    .wl-cal .col { flex: 1; position: relative; border-left: 1px solid rgba(255,255,255,.15); }
    .wl-cal .col .line { position: absolute; left: 0; right: 0; border-top: 1px solid rgba(255,255,255,.08); }
    .wl-cal .col .blk { position: absolute; box-sizing: border-box; padding: .2em .35em; border-radius: .3em; overflow: hidden; font-size: .8em; line-height: 1.2; }
    .wl-cal .col .blk b { display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .wl-cal .col .blk.past { opacity: .45; }
    .wl-cal .col .nowl { position: absolute; left: 0; right: 0; height: 0; border-top: .18em solid; z-index: 2; }
    .wl-cal .heads { display: flex; margin-left: 3.2em; font-size: .75em; font-weight: 700; }
    .wl-cal .heads div { flex: 1; text-align: center; padding-bottom: .3em; overflow: hidden; white-space: nowrap; }
    .wl-cal .allday { display: flex; margin-left: 3.2em; gap: .3em; font-size: .75em; margin-bottom: .3em; }
    .wl-cal .allday div { flex: 1; display: flex; flex-direction: column; gap: .2em; min-width: 0; }
    .wl-cal .allday span { padding: .1em .35em; border-radius: .3em; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .wl-tab .wrap { flex: 1; min-height: 0; position: relative; }
    .wl-tab table { width: 100%; border-collapse: collapse; table-layout: auto; }
    .wl-tab th { text-align: left; padding: .45em .6em; font-weight: 700; white-space: nowrap; }
    .wl-tab td { padding: .4em .6em; border-bottom: 1px solid rgba(255,255,255,.12); overflow: hidden; text-overflow: ellipsis; max-width: 30em; }
    .wl-tab tr.z td { background: rgba(255,255,255,.05); }
    .wl-tab .num { text-align: right; font-variant-numeric: tabular-nums; }
    .wl-tab .pg { position: absolute; right: 0; bottom: 0; font-size: .65em; opacity: .7; }
    .wl-data-msg { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; text-align: center; opacity: .7; padding: 2cqh; box-sizing: border-box; }
  `;
/** Texte der Bausteine (Player-Sprache). */
const TXT = {
    de: { choose: 'Datenquelle wählen', noData: 'Noch keine Daten', wrong: 'Datenquelle passt nicht zu diesem Baustein', noItems: 'Keine Beiträge',
        noEvents: 'Heute keine Termine', noEventsWeek: 'Keine Termine in den nächsten 7 Tagen', allDay: 'Ganztägig', today: 'Heute', tomorrow: 'Morgen', noRows: 'Keine Einträge' },
    en: { choose: 'Choose a data source', noData: 'No data yet', wrong: 'Data source does not match this block', noItems: 'No posts',
        noEvents: 'No events today', noEventsWeek: 'No events in the next 7 days', allDay: 'All day', today: 'Today', tomorrow: 'Tomorrow', noRows: 'No entries' },
};
const tx = (ctx) => (ctx.locale.startsWith('en') ? TXT.en : TXT.de);
function msg(ctx, box, text, style = '') {
    clear(box);
    box.appendChild(h(ctx.doc, 'div', { class: 'wl-data-msg', style, text }));
}
/** Daten der Quelle eines Bausteins, oder Hinweis im Kasten (dann null). */
function dataFor(box, source, kind, ctx, style) {
    if (!source) {
        placeholder(ctx.doc, box, tx(ctx).choose);
        return null;
    }
    const d = ctx.data(source);
    if (!d) {
        msg(ctx, box, tx(ctx).noData, style);
        return null;
    }
    if (d.kind !== kind) {
        msg(ctx, box, tx(ctx).wrong, style);
        return null;
    }
    return d;
}
const baseStyle = (el, size) => `color:${cssSafe(el.color || '#fff')};font-size:${Number(el.size) || size}cqh;` + (el.align ? `text-align:${cssSafe(el.align)};` : '') +
    (el.bold ? 'font-weight:700;' : '') + (el.font && FONT_STACKS[el.font] ? `font-family:${FONT_STACKS[el.font]};` : '');
function fmt(ctx, at, o) {
    return new Date(at).toLocaleString(ctx.locale, { ...o, ...(ctx.timeZone ? { timeZone: ctx.timeZone } : {}) });
}
const hhmm = (ctx, at) => fmt(ctx, at, { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
// ---------- Newsticker / Feed ----------
function feedDate(ctx, iso) {
    const t = iso ? Date.parse(iso) : NaN;
    if (!Number.isFinite(t))
        return '';
    const today = ymdIn(ctx.now(), ctx.timeZone);
    return ymdIn(t, ctx.timeZone) === today ? hhmm(ctx, t) : fmt(ctx, t, { day: 'numeric', month: 'short' });
}
export const feedWidget = {
    label: 'Newsticker',
    defaults: { source: '', mode: 'ticker', count: 10, images: true, showDate: true, showText: true, speed: 25, interval: 8, size: 4.5, color: '#ffffff', bg: '#111827', accent: '#f5c518' },
    render(box, el, ctx) {
        const { doc } = ctx;
        const style = baseStyle(el, 4.5);
        const data = dataFor(box, el.source, 'feed', ctx, style);
        if (!data)
            return;
        const items = data.items.slice(0, Math.max(1, Math.min(20, Number(el.count) || 10)));
        if (!items.length)
            return msg(ctx, box, tx(ctx).noItems, style);
        const accent = cssSafe(el.accent || '#f5c518');
        const typo = (el.weight ? `font-weight:${Math.round(Number(el.weight))};` : '') + (el.italic ? 'font-style:italic;' : '') + (el.upper ? 'text-transform:uppercase;' : '');
        clear(box);
        const mode = el.mode ?? 'ticker';
        if (mode === 'ticker') {
            const span = h(doc, 'span', { class: 'ft' });
            items.forEach((it, i) => {
                if (i)
                    span.appendChild(h(doc, 'span', { class: 'sep', style: `color:${accent}`, text: '+++' }));
                const d = el.showDate ? feedDate(ctx, it.date) : '';
                if (d)
                    span.appendChild(h(doc, 'span', { style: `color:${accent};font-weight:700;margin-right:.5em`, text: d }));
                span.appendChild(doc.createTextNode(it.title));
            });
            const chars = items.reduce((n, it) => n + it.title.length + 8, 0);
            span.style.animationDuration = `${Math.max(5, Number(el.speed) || 25) * Math.max(1, chars / 120)}s`;
            box.appendChild(h(doc, 'div', { class: 'wl-feed tk', style: style + typo }, [span]));
            return;
        }
        const image = (sha) => (el.images !== false && sha ? ctx.resolveAsset(sha) : '');
        const texts = (it) => {
            const out = [];
            const d = el.showDate !== false ? feedDate(ctx, it.date) : '';
            if (d)
                out.push(h(doc, 'div', { class: 'dt', style: `color:${accent}`, text: d }));
            out.push(h(doc, 'div', { class: 'tt', text: it.title }));
            if (el.showText !== false && it.text)
                out.push(h(doc, 'div', { class: 'tx', text: it.text }));
            return out;
        };
        const wrap = h(doc, 'div', { class: 'wl-feed', style: style + typo });
        box.appendChild(wrap);
        if (mode === 'list') {
            const list = h(doc, 'div', { class: 'list' });
            if (el.title)
                list.appendChild(h(doc, 'h2', { style: `color:${accent}`, text: el.title }));
            for (const it of items) {
                const src = image(it.image);
                list.appendChild(h(doc, 'div', { class: 'it' }, [
                    ...(src ? [h(doc, 'img', { attrs: { src, alt: '' } })] : []),
                    h(doc, 'div', { style: 'min-width:0' }, texts(it)),
                ]));
            }
            wrap.appendChild(list);
            return;
        }
        // Karten: ein Beitrag nach dem anderen
        const wide = el.w > 0 && el.h > 0 && el.w * 16 > el.h * 9 * 1.9;
        const cards = items.map((it, i) => {
            const src = image(it.image);
            return h(doc, 'div', { class: `card${wide && src ? ' wide' : ''}${i ? '' : ' on'}` }, [
                ...(src ? [h(doc, 'img', { attrs: { src, alt: '' } })] : []),
                h(doc, 'div', { class: 'body' }, texts(it)),
            ]);
        });
        wrap.appendChild(h(doc, 'div', { class: 'cards' }, cards));
        if (cards.length < 2)
            return;
        let i = 0;
        const t = setInterval(() => {
            cards[i].classList.remove('on');
            i = (i + 1) % cards.length;
            cards[i].classList.add('on');
        }, Math.max(3, Number(el.interval) || 8) * 1000);
        return () => clearInterval(t);
    },
};
// ---------- Termine ----------
function eventTime(ctx, e, day) {
    if (e.allDay)
        return tx(ctx).allDay;
    const s = eventSpan(e, ctx.timeZone);
    const from = ymdIn(s.start, ctx.timeZone) === day ? hhmm(ctx, s.start) : '…';
    const until = s.end > s.start ? (ymdIn(s.end - 1, ctx.timeZone) === day ? hhmm(ctx, s.end) : '…') : '';
    return until ? `${from}–${until}` : from;
}
function dayLabel(ctx, day, today) {
    if (day === today)
        return tx(ctx).today;
    if (day === addDays(today, 1))
        return tx(ctx).tomorrow;
    return new Date(`${day}T12:00:00Z`).toLocaleDateString(ctx.locale, { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
}
export const calendarWidget = {
    label: 'Termine',
    defaults: { source: '', range: 'today', view: 'list', title: 'Termine heute', size: 3.4, color: '#ffffff', accent: '#f5c518', showLocation: true, maxItems: 12, bg: '#111827' },
    render(box, el, ctx) {
        const { doc } = ctx;
        const style = baseStyle(el, 3.4);
        const accent = cssSafe(el.accent || '#f5c518');
        const draw = () => {
            const data = dataFor(box, el.source, 'calendar', ctx, style);
            if (!data)
                return;
            const now = ctx.now();
            const today = ymdIn(now, ctx.timeZone);
            const days = el.range === 'week' ? [0, 1, 2, 3, 4, 5, 6].map((n) => addDays(today, n)) : [today];
            clear(box);
            const wrap = h(doc, 'div', { class: 'wl-cal', style });
            if (el.title)
                wrap.appendChild(h(doc, 'h2', { style: `color:${accent}`, text: el.title }));
            box.appendChild(wrap);
            if (el.view === 'day')
                return dayGrid(ctx, wrap, data.events, days, today, now, accent);
            const rows = h(doc, 'div', { class: 'rows' });
            wrap.appendChild(rows);
            let left = Math.max(1, Math.min(50, Number(el.maxItems) || 12));
            for (const day of days) {
                const evs = eventsOnDay(data.events, day, ctx.timeZone);
                if (!evs.length || left <= 0)
                    continue;
                if (days.length > 1)
                    rows.appendChild(h(doc, 'div', { class: 'day', style: `color:${accent}`, text: dayLabel(ctx, day, today) }));
                for (const e of evs.slice(0, left)) {
                    const s = eventSpan(e, ctx.timeZone);
                    const past = s.end <= now && !(e.allDay && day === today);
                    const running = !past && s.start <= now && now < s.end;
                    rows.appendChild(h(doc, 'div', { class: `ev${past ? ' past' : ''}`, style: running ? `border-left-color:${accent}` : '' }, [
                        h(doc, 'div', { class: 't', style: `color:${accent}`, text: eventTime(ctx, e, day) }),
                        h(doc, 'div', { class: 'n' }, [
                            h(doc, 'b', { text: e.title }),
                            ...(el.showLocation !== false && e.location ? [h(doc, 'small', { text: e.location })] : []),
                        ]),
                    ]));
                    left--;
                }
            }
            if (!rows.childNodes.length)
                rows.appendChild(h(doc, 'div', { class: 'wl-data-msg', text: days.length > 1 ? tx(ctx).noEventsWeek : tx(ctx).noEvents }));
        };
        draw();
        // Jede Minute neu: vergangene Termine abblenden, Tageswechsel um Mitternacht
        const t = setInterval(draw, 60_000);
        return () => clearInterval(t);
    },
};
/** Tagesansicht: Stundenraster, eine Spalte je Tag, Termine als Blöcke, Linie für „jetzt". */
function dayGrid(ctx, wrap, events, days, today, now, accent) {
    const { doc } = ctx;
    const perDay = days.map((d) => ({ d, evs: eventsOnDay(events, d, ctx.timeZone), from: zonedMidnight(d, ctx.timeZone) }));
    // Stundenbereich aus den Terminen (mind. 6 Stunden, Standard 8–20 Uhr)
    let minH = 8;
    let maxH = 20;
    for (const { evs, from } of perDay) {
        for (const e of evs) {
            if (e.allDay)
                continue;
            const s = eventSpan(e, ctx.timeZone);
            minH = Math.min(minH, Math.max(0, Math.floor((s.start - from) / 3_600_000)));
            maxH = Math.max(maxH, Math.min(24, Math.ceil((s.end - from) / 3_600_000)));
        }
    }
    if (maxH - minH < 6)
        maxH = Math.min(24, minH + 6);
    const span = (maxH - minH) * 3_600_000;
    if (days.length > 1) {
        wrap.appendChild(h(doc, 'div', { class: 'heads' }, days.map((d) => h(doc, 'div', {
            style: d === today ? `color:${accent}` : '',
            text: new Date(`${d}T12:00:00Z`).toLocaleDateString(ctx.locale, { weekday: 'short', day: 'numeric', timeZone: 'UTC' }),
        }))));
    }
    if (perDay.some((p) => p.evs.some((e) => e.allDay))) {
        wrap.appendChild(h(doc, 'div', { class: 'allday' }, perDay.map((p) => h(doc, 'div', {}, p.evs.filter((e) => e.allDay).slice(0, 3)
            .map((e) => h(doc, 'span', { style: `background:${accent};color:#111`, text: e.title }))))));
    }
    const grid = h(doc, 'div', { class: 'grid' });
    const hours = h(doc, 'div', { class: 'hours' });
    for (let hr = minH; hr <= maxH; hr += maxH - minH > 12 ? 2 : 1) {
        hours.appendChild(h(doc, 'span', { style: `top:${((hr - minH) * 3_600_000 / span) * 100}%`, text: `${String(hr).padStart(2, '0')}:00` }));
    }
    grid.appendChild(hours);
    for (const { d, evs, from } of perDay) {
        const col = h(doc, 'div', { class: 'col' });
        for (let hr = minH; hr <= maxH; hr++)
            col.appendChild(h(doc, 'div', { class: 'line', style: `top:${((hr - minH) * 3_600_000 / span) * 100}%` }));
        const timed = evs.filter((e) => !e.allDay).map((e) => {
            const s = eventSpan(e, ctx.timeZone);
            const a = Math.max(s.start, from + minH * 3_600_000);
            const b = Math.min(Math.max(s.end, s.start + 15 * 60_000), from + maxH * 3_600_000);
            return { e, s, a, b, lane: 0 };
        }).filter((x) => x.b > x.a);
        // Überlappende Termine nebeneinander (einfache Spurenzuteilung)
        const lanes = [];
        for (const x of timed) {
            let lane = lanes.findIndex((end) => end <= x.a);
            if (lane < 0)
                lane = lanes.push(0) - 1;
            lanes[lane] = x.b;
            x.lane = lane;
        }
        const n = Math.max(1, lanes.length);
        for (const x of timed) {
            const top = ((x.a - from - minH * 3_600_000) / span) * 100;
            const height = ((x.b - x.a) / span) * 100;
            col.appendChild(h(doc, 'div', {
                class: `blk${x.s.end <= now ? ' past' : ''}`,
                style: `top:${top}%;height:${height}%;left:${(x.lane / n) * 100}%;width:${100 / n}%;background:${accent};color:#111`,
            }, [h(doc, 'b', { text: x.e.title }), h(doc, 'span', { text: eventTime(ctx, x.e, d) })]));
        }
        if (d === today && now >= from + minH * 3_600_000 && now <= from + maxH * 3_600_000) {
            col.appendChild(h(doc, 'div', { class: 'nowl', style: `top:${((now - from - minH * 3_600_000) / span) * 100}%;border-color:${accent}` }));
        }
        grid.appendChild(col);
    }
    wrap.appendChild(grid);
}
// ---------- Tabelle ----------
const NUM_RE = /^[-+]?\d{1,3}(?:[ '’.,]?\d{3})*(?:[.,]\d+)?\s*%?$/;
function cellText(ctx, v, type) {
    if (type === 'date' && /^\d{4}-\d{2}-\d{2}$/.test(v)) {
        return new Date(`${v}T12:00:00Z`).toLocaleDateString(ctx.locale, { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC' });
    }
    return v;
}
export const tableWidget = {
    label: 'Tabelle',
    defaults: { source: '', header: true, rowsPerPage: 8, pageSeconds: 8, stripes: true, size: 3.2, color: '#ffffff', accent: '#1f2937', headColor: '#f5c518', bg: '#111827' },
    render(box, el, ctx) {
        const { doc } = ctx;
        const style = baseStyle(el, 3.2);
        const data = dataFor(box, el.source, 'table', ctx, style);
        if (!data)
            return;
        const wanted = (el.columns ?? []).filter(Boolean);
        const cols = (wanted.length ? wanted.map((k) => data.columns.findIndex((c) => c.key === k)) : data.columns.map((_, i) => i)).filter((i) => i >= 0);
        const todayCol = el.today ? data.columns.findIndex((c) => c.key === el.today) : -1;
        const numeric = cols.map((i) => data.columns[i].type === 'number' || (data.rows.length > 0 && data.rows.every((r) => !r[i] || NUM_RE.test(r[i].trim()))));
        const perPage = Math.max(1, Math.min(50, Number(el.rowsPerPage) || 8));
        const head = cssSafe(el.headColor || '#f5c518');
        let page = 0;
        const draw = () => {
            const today = ymdIn(ctx.now(), ctx.timeZone);
            const rows = todayCol >= 0 ? data.rows.filter((r) => cellMatchesDay(r[todayCol] ?? '', today)) : data.rows;
            const pages = Math.max(1, Math.ceil(rows.length / perPage));
            if (page >= pages)
                page = 0;
            clear(box);
            const wrap = h(doc, 'div', { class: 'wl-tab', style });
            if (el.title)
                wrap.appendChild(h(doc, 'h2', { style: `color:${head}`, text: el.title }));
            const inner = h(doc, 'div', { class: 'wrap' });
            wrap.appendChild(inner);
            box.appendChild(wrap);
            if (!rows.length) {
                inner.appendChild(h(doc, 'div', { class: 'wl-data-msg', text: tx(ctx).noRows }));
                return;
            }
            const table = h(doc, 'table');
            if (el.header !== false) {
                table.appendChild(h(doc, 'thead', {}, [h(doc, 'tr', {}, cols.map((i, j) => h(doc, 'th', {
                        class: numeric[j] ? 'num' : '', style: `color:${head};background:${cssSafe(el.accent || '#1f2937')}`, text: data.columns[i].label,
                    })))]));
            }
            const body = rows.slice(page * perPage, page * perPage + perPage).map((r, n) => h(doc, 'tr', { class: el.stripes !== false && n % 2 ? 'z' : '' }, cols.map((i, j) => h(doc, 'td', { class: numeric[j] ? 'num' : '', text: cellText(ctx, r[i] ?? '', data.columns[i].type) }))));
            table.appendChild(h(doc, 'tbody', {}, body));
            inner.appendChild(table);
            if (pages > 1)
                inner.appendChild(h(doc, 'div', { class: 'pg', text: `${page + 1} / ${pages}` }));
        };
        draw();
        const t = setInterval(() => {
            page++;
            draw();
        }, Math.max(3, Number(el.pageSeconds) || 8) * 1000);
        return () => clearInterval(t);
    },
};
export const DATA_WIDGETS = { feed: feedWidget, calendar: calendarWidget, table: tableWidget };
//# sourceMappingURL=data-widgets.js.map